import styled from "styled-components";

import FnrContainedIcon from "UI/FnrContainedIcon";

import { useHeaderTextColor } from "../stateHooks";

const FlyingAirplane = () => {
  const textColor = useHeaderTextColor();

  return (
    <AnimationWrapper>
      <AnimatedIcon>
        <FnrContainedIcon
          color={textColor}
          size="decorative3"
          icon="fa-paper-plane fas"
        />
      </AnimatedIcon>
      <SpaceForFlyingIcon />
    </AnimationWrapper>
  );
};

const AnimatedIcon = styled.div`
  @keyframes flyAround {
    100%,
    0% {
      transform: translate(0, 30px) rotate(0deg) scale(2.5);
    }
    12% {
      transform: translate(50px, 0px) rotate(10deg) scale(1.25);
    }
    24% {
      transform: translate(100px, -15px) rotate(20deg) scale(0.9);
    }
    50% {
      transform: translate(175px, -22px) rotate(30deg) scale(0.45);
    }
    100% {
      transform: translate(280px, -30px) rotate(40deg) scale(0);
    }
  }
  position: absolute;
  animation: flyAround 1.25s linear forwards; /* Apply animation */
`;

const AnimationWrapper = styled.div`
  transform: scaleX(-1);
`;

const SpaceForFlyingIcon = styled.div`
  height: 104px;
  transform: scaleX(-1);
`;

export default FlyingAirplane;
